export const SET_MATERIALITY_ASSESSMENT_TASK_LIST =
  "SET_MATERIALITY_ASSESSMENT_TASK_LIST";
export const SET_MATERIALITY_SELECTED_TASK = "SET_MATERIALITY_SELECTED_TASK";
export const SET_SUBMITTED_MATERIALITY_DATA = "SET_SUBMITTED_MATERIALITY_DATA";
